import React from 'react';
import { PageFrame } from '../components/PageFrame';
import { plans } from '../components/marketingContent';

type Props = {
  onPrimaryCta: () => void;
  onSecondaryCta: () => void;
};

export function PricingPage({ onPrimaryCta, onSecondaryCta }: Props) {
  return (
    <PageFrame title="Pricing" onPrimaryCta={onPrimaryCta} onSecondaryCta={onSecondaryCta}>
      <section id="pricing" className="section">
        <div className="container">
          <div className="section-heading">
            <div>
              <h1 className="section-title">Pricing</h1>
              <h2 className="section-subtitle">Start free. Scale when the signals prove out.</h2>
            </div>
            <p className="section-description">
              No procurement maze. Pick a plan, ship your first alerts, and upgrade when you need unlimited coverage
              and delivery channels.
            </p>
          </div>
            <div className="pricing-grid">
              {plans.map((plan) => (
                <div className={`pricing-card ${plan.recommended ? 'recommended' : ''}`} key={plan.name}>
                  <h3>{plan.name}</h3>
                  <div className="price">
                    {plan.price} <small>{plan.cadence}</small>
                  </div>
                <p className="price-note">{plan.note}</p>
                <ul className="plan-features">
                  {plan.features.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <button
                  className={plan.recommended ? 'cta-button' : 'cta-secondary'}
                  type="button"
                  onClick={plan.recommended ? onPrimaryCta : onSecondaryCta}
                >
                  {plan.recommended ? 'Upgrade to Pro' : 'Start free'}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageFrame>
  );
}
